import { render, staticRenderFns } from "./maskFrom.vue?vue&type=template&id=780776c3&scoped=true"
import script from "./maskFrom.vue?vue&type=script&lang=js"
export * from "./maskFrom.vue?vue&type=script&lang=js"
import style0 from "./maskFrom.vue?vue&type=style&index=0&id=780776c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780776c3",
  null
  
)

export default component.exports